module.exports = __webpack_public_path__ + "static/media/mobile-search.14bb568f.svg";